validatePhone = {
	phoneValid: false,
	errorCount: 0,
	cP: $("#customPhone")[0],
	showCustomPhoneError:function(type) {
		var tType = type;
		if (type == null) return;
		if ( type === 'voip'){
			tType = 'VOIP';
		}
		var cM = "This phone number is a " + tType + ". Please enter a valid mobile phone number.";
		this.cP.innerHTML = cM;
		$(validatePhone.cP).show();
	},
	hideCustomPhoneError:function() {
		$(validatePhone.cP).hide();
	},
	validatePhoneTwilio: function(phone) {
		validatePhone.hideCustomPhoneError();
		// If there have already been 2 errors, let this pass (having already verified it's a good number via regex)
		if(validatePhone.errorCount >= 2) return true;

		var type = 'carrier';
		var json = '{"type":"'+type+'","phone":"'+phone+'"}';

		$.ajax({
			type: "POST",
			url: '/services/validatephone/',
			data: json,
			dataType: 'json'
		}).done(function(d){
			var t = d.type;
			if(t !== "mobile" && validatePhone.errorCount < 2) {
				this.phoneValid = false;
				validatePhone.showCustomPhoneError(t);
				validatePhone.errorCount++;
				return false;
			}
			validatePhone.phoneValid = true;
			return true;
		})
	},
}
